﻿(function () {
  var marketoListener = setInterval(function () {
    if (typeof MktoForms2.loadForm === 'function') {
      loadMarketoForm();
      clearInterval(marketoListener);
    }
  }, 1200);

  function loadMarketoForm() {
    let form = $('#formPlaceholder');
    let link = form.data('tracking-link');
    let code = form.data('munchkin-code');
    let id = form.data('form-id');

    MktoForms2.loadForm(link, code, id, function (form) {
      MktoForms2.$('#formPlaceholder').append(form.getFormElem());
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'mkto.form.js',
        'mkto.form.start': new Date().getTime(),
      });

      function waitForError() {
        var element, input, mktoErrorMsg;
        element = document.querySelector('.mktoErrorMsg');
        if (element) {
          mktoErrorMsg = element.textContent || element.innerText;
          input = document.querySelector(
            'input.mktoInvalid, .mktoInvalid input',
          );
          window.dataLayer.push({
            event: 'mkto.form.error',
            'mkto.form.error.message': mktoErrorMsg,
            'gtm.element': input,
            'gtm.elementClasses': (input && input.className) || '',
            'gtm.elementId': (input && input.id) || '',
            'gtm.elementName': (input && input.name) || '',
            'gtm.elementTarget': (input && input.target) || '',
          });
        }
      }

      function addMktoForms2Listeners(MktoForms2) {
        window.dataLayer.push({
          event: 'mkto.form.ready',
          'mkto.form.id': form.getId(),
          'mkto.form.submittable': form.submittable(),
          'mkto.form.allFieldsFilled': form.allFieldsFilled(),
          'mkto.form.values': form.getValues(),
        });
        form.onValidate(function handleValidate(valid) {
          window.dataLayer.push({
            event: 'mkto.form.validate',
            'mkto.form.valid': valid,
          });
          setTimeout(waitForError, 0);
        });
        form.onSubmit(function handleSubmit(thisForm) {
          var button;
          button = thisForm.getFormElem().find('button[type="submit"]');
          window.dataLayer.push({
            event: 'mkto.form.submit',
            'mkto.form.id': thisForm.getId(),
            'mkto.form.submittable': thisForm.submittable(),
            'mkto.form.allFieldsFilled': thisForm.allFieldsFilled(),
            'mkto.form.values': thisForm.getValues(),
            'mkto.form.button': {
              classes: button.attr('class<span class="code - quote">'),
              text: button.text(),
              type: 'submit',
            },
          });
        });
        form.onSuccess(function handleSuccess(values, followUpUrl) {
          window.dataLayer.push({
            event: 'mkto.form.success',
            'mkto.form.values': values,
            'mkto.form.followUpUrl': followUpUrl,
          });
        });
      }

      addMktoForms2Listeners(MktoForms2);
    });
  }
})();
